import React from "react";

function PCLogoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M9.73107 3.52353L8.8865 7.99905H19.5311L20.0378 5.41639C21.7207 7.69225 23.5856 9.82231 25.6134 11.7848L17.8419 17.6384L18.3486 15.0557L7.70264 14.7116L5 29H11.2513L12.9405 20.049C21.2202 21.0874 28.6554 18.6723 28.9932 10.2375C29.331 1.80275 16.9973 2.66314 9.73107 3.52353Z"
        fill="#2C7FDB"
      />
    </svg>
  );
}

export default PCLogoIcon;
